import type { StateCreator } from 'zustand';
import type { AppStore } from './types';
import type { CloudUser } from '@/infra/cloud/CloudClient';

export type CloudSyncStatus = 'idle' | 'syncing' | 'synced' | 'error' | 'disabled';

export interface CloudSliceState {
  cloudUser: CloudUser | null;
  cloudSyncStatus: CloudSyncStatus;
  cloudLastSyncAt: number | null;
  cloudLastError: string | null;
}

export interface CloudSliceActions {
  setCloudUser: (u: CloudUser | null) => void;
  setCloudSyncStatus: (s: CloudSyncStatus) => void;
  setCloudLastSyncAt: (t: number | null) => void;
  setCloudLastError: (e: string | null) => void;
}

export type CloudSlice = CloudSliceState & CloudSliceActions;

export const createCloudSlice: StateCreator<AppStore, [], [], CloudSlice> = (set) => ({
  cloudUser: null,
  cloudSyncStatus: 'idle',
  cloudLastSyncAt: null,
  cloudLastError: null,
  setCloudUser: (cloudUser) => set({ cloudUser }),
  setCloudSyncStatus: (cloudSyncStatus) => set({ cloudSyncStatus }),
  setCloudLastSyncAt: (cloudLastSyncAt) => set({ cloudLastSyncAt }),
  setCloudLastError: (cloudLastError) => set({ cloudLastError }),
});
